import { render } from "./CountryDistributionChart.vue?vue&type=template&id=666440f4&scoped=true"
import script from "./CountryDistributionChart.vue?vue&type=script&lang=js"
export * from "./CountryDistributionChart.vue?vue&type=script&lang=js"

import "./CountryDistributionChart.vue?vue&type=style&index=0&id=666440f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666440f4"],['__file',"src/components/CountryDistributionChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "666440f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('666440f4', __exports__)) {
    api.reload('666440f4', __exports__)
  }
  
  module.hot.accept("./CountryDistributionChart.vue?vue&type=template&id=666440f4&scoped=true", () => {
    api.rerender('666440f4', render)
  })

}


export default __exports__